import { apiClient } from './apiClient';
import { ImpactStory } from '../types';

export const ImpactStoryService = {
  getImpactStories: async (): Promise<ImpactStory[]> => {
    const response = await apiClient.get('/impact-stories');
    return response.data;
  },

  getImpactStoryById: async (id: string): Promise<ImpactStory> => {
    const response = await apiClient.get(`/impact-stories/${id}`);
    return response.data;
  },

  createImpactStory: async (
    storyData: Omit<ImpactStory, 'id' | 'createdAt' | 'updatedAt'>
  ): Promise<ImpactStory> => {
    const response = await apiClient.post('/impact-stories', storyData);
    return response.data;
  },

  updateImpactStory: async (
    id: string,
    storyData: Partial<Omit<ImpactStory, 'id' | 'createdAt' | 'updatedAt'>>
  ): Promise<ImpactStory> => {
    const response = await apiClient.put(`/impact-stories/${id}`, storyData);
    return response.data;
  },

  deleteImpactStory: async (id: string): Promise<void> => {
    await apiClient.delete(`/impact-stories/${id}`);
  },
};
